(function(){
  var stage=document.querySelector('[data-stage]'); if(!stage) return;
  var lamp=stage.querySelector('.lamp'), logo=stage.querySelector('.floor-logo'), flashes=stage.querySelector('.stage-flashes');
  var canvas=stage.querySelector('.stage-haze'), ctx=canvas&&canvas.getContext('2d');
  var glow=document.querySelector('.stage-glow'), ring=document.querySelector('.stage-cursor');
  var product=document.querySelector('.tpl-index .hdr__product');
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=window.matchMedia('(pointer: fine)').matches;
  var W=0,H=0,DPR=1,spotH=0;
  var tx=0,ty=0,cx=0,cy=0,lastMove=-1e9,px=-9999,py=-9999,rx=-9999,ry=-9999,flash=0;
  var MAX=12; // max beam swing in degrees

  if(fine && !reduce){ document.documentElement.classList.add('has-stage-cursor'); }

  function measure(){
    var r=stage.getBoundingClientRect(); W=r.width; H=r.height;
    DPR=Math.min(window.devicePixelRatio||1,1.5);
    if(canvas){ canvas.width=Math.round(W*DPR); canvas.height=Math.round(H*DPR); }
    var svg=stage.querySelector('.spot__svg'); spotH=svg?svg.getBoundingClientRect().height:H*.58;
  }
  measure(); window.addEventListener('resize',measure);

  // pointer input (mouse, pen, touch)
  window.addEventListener('pointermove',function(e){
    tx=Math.max(-1,Math.min(1,e.clientX/window.innerWidth*2-1));
    ty=Math.max(-1,Math.min(1,e.clientY/window.innerHeight*2-1));
    px=e.clientX; py=e.clientY; lastMove=performance.now();
    if(ring&&e.pointerType==='mouse'){ ring.classList.add('is-live'); glow&&glow.classList.add('is-live'); }
    if(product){
      var b=product.getBoundingClientRect(), mx=b.left+b.width/2, my=b.top+b.height/2, dx=e.clientX-mx, dy=e.clientY-my, d=Math.hypot(dx,dy);
      if(d<110){ product.style.setProperty('--mx',(dx*.18).toFixed(1)+'px'); product.style.setProperty('--my',(dy*.25).toFixed(1)+'px'); }
      else { product.style.setProperty('--mx','0px'); product.style.setProperty('--my','0px'); }
    }
    if(ring){
      var t=e.target.closest&&e.target.closest('a,button,[role="button"],.home__emblem');
      ring.classList.toggle('is-hover',!!t);
    }
  },{passive:true});
  window.addEventListener('pointerdown',function(){ ring&&ring.classList.add('is-down'); });
  window.addEventListener('pointerup',function(){ ring&&ring.classList.remove('is-down'); });
  document.documentElement.addEventListener('mouseleave',function(){ lastMove=-1e9; px=py=-9999; ring&&ring.classList.remove('is-live'); glow&&glow.classList.remove('is-live'); });

  // paparazzi flashes on the logo
  function paparazzi(){
    var b=logo.getBoundingClientRect(), s=stage.getBoundingClientRect(), n=reduce?2:6;
    for(var i=0;i<n;i++){ (function(i){ setTimeout(function(){
      var f=document.createElement('div'); f.className='stage-flash';
      var x=b.left-s.left+b.width*(-.15+Math.random()*1.3), y=b.top-s.top+b.height*(-1.2+Math.random()*2.2);
      f.style.left=x+'px'; f.style.top=y+'px'; f.style.setProperty('--s',(110+Math.random()*130|0)+'px');
      flashes.appendChild(f); flash=.9; setTimeout(function(){ f.remove(); },420);
    }, i*(90+Math.random()*110)); })(i); }
  }
  if(logo){
    logo.addEventListener('click',paparazzi);
    logo.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); paparazzi(); } });
  }

  // blackout transition when leaving the homepage
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href]'); if(!a) return;
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||a.target==='_blank') return;
    var url=new URL(a.href,location.href); if(url.origin!==location.origin||url.href===location.href||a.hasAttribute('download')) return;
    if(url.pathname===location.pathname && url.hash) return;
    e.preventDefault(); document.documentElement.classList.add('is-leaving');
    setTimeout(function(){ location.href=url.href; }, reduce?60:480);
  });
  window.addEventListener('pageshow',function(){ document.documentElement.classList.remove('is-leaving'); });

  // haze particles
  var sprite=document.createElement('canvas'); sprite.width=sprite.height=128;
  (function(){ var g=sprite.getContext('2d'), gr=g.createRadialGradient(64,64,0,64,64,64);
    gr.addColorStop(0,'rgba(255,250,240,1)'); gr.addColorStop(.4,'rgba(255,250,240,.45)'); gr.addColorStop(1,'rgba(255,250,240,0)');
    g.fillStyle=gr; g.fillRect(0,0,128,128); })();
  var parts=[], N=window.innerWidth<600?26:52;
  for(var i=0;i<N;i++) parts.push({x:Math.random(),y:Math.random(),r:90+Math.random()*170,vx:(Math.random()-.5)*.00012,vy:-(.00003+Math.random()*.00008),ph:Math.random()*6.28});

  function drawHaze(theta,now){
    if(!ctx) return;
    ctx.setTransform(DPR,0,0,DPR,0,0); ctx.clearRect(0,0,W,H); ctx.globalCompositeOperation='lighter';
    var unit=spotH/600, sx=W/2, sy=-80*unit, floorY=512*unit, tan=Math.tan(theta);
    for(var i=0;i<parts.length;i++){
      var p=parts[i]; p.x+=p.vx; p.y+=p.vy; if(p.y<-.15){p.y=1.1;p.x=Math.random();} if(p.x<-.15)p.x=1.1; if(p.x>1.15)p.x=-.1;
      var x=p.x*W+Math.sin(now*.0002+p.ph)*18, y=p.y*H;
      var beamF=0; if(y>sy && y<floorY+40){ var c=sx+tan*(y-sy), hw=(38+(y-sy)/592*184)*unit; beamF=Math.max(0,1-Math.abs(x-c)/hw); }
      var curF=px>-999?Math.max(0,1-Math.hypot(x-px,y-py)/280):0;
      var a=.0018+.085*beamF*beamF+.028*curF; if(a<.0025) continue;
      ctx.globalAlpha=a; ctx.drawImage(sprite,x-p.r,y-p.r,p.r*2,p.r*2);
    }
    ctx.globalAlpha=1;
  }

  function apply(){
    var theta=cx*MAX*Math.PI/180, poolx=Math.tan(theta)*592;
    var lit=1-Math.min(1,Math.abs(poolx)/224)*.75;
    lamp.style.setProperty('--beam',(-cx*MAX).toFixed(2)+'deg');
    lamp.style.setProperty('--poolx',poolx.toFixed(1)+'px');
    lamp.style.setProperty('--lit',(.42+.58*lit).toFixed(3));
    lamp.style.setProperty('--ry',(cx*16).toFixed(2)+'deg');
    lamp.style.setProperty('--rx',(-cy*7).toFixed(2)+'deg');
    lamp.style.setProperty('--flash',flash.toFixed(2));
    return theta;
  }

  if(reduce){ apply(); drawHaze(0,0); return; }

  var running=true;
  document.addEventListener('visibilitychange',function(){ running=!document.hidden; if(running) requestAnimationFrame(loop); });
  function loop(now){
    if(!running) return;
    var idle=now-lastMove>2600;
    var gx=idle?Math.sin(now*.00035)*.38:tx, gy=idle?Math.sin(now*.00027)*.25:ty;
    cx+=(gx-cx)*.055; cy+=(gy-cy)*.055; flash*=.9; if(flash<.01) flash=0;
    var theta=apply(); drawHaze(theta,now);
    if(px>-999){
      if(rx<-999){rx=px;ry=py;}
      rx+=(px-rx)*.35; ry+=(py-ry)*.35;
      if(ring) ring.style.transform='translate('+rx.toFixed(1)+'px,'+ry.toFixed(1)+'px)';
      if(glow) glow.style.transform='translate('+(px).toFixed(1)+'px,'+(py).toFixed(1)+'px)';
    }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
})();
